/**
 * ゴミ箱に入っているキャンバスへの編集を拒否するときの共通文言。
 * サーバの拒否理由、クライアントのお知らせ、常設バナーで同じ文言を使う。
 */
export const CANVAS_TRASHED_EDIT_MESSAGE =
  "このキャンバスはゴミ箱に入っています。編集する場合はゴミ箱から戻してください。";
